VjsAdmin.DistrictUsersBulkUploadValidate = (function () {
    const init = function () {
        const districtLicenses = {};
        const fz = FuzzySet();
        $('#bulk-uploads-licenses .license-id-selection')
            .first()
            .find('option')
            .each((index, el) => {
                const value = $(el).val();
                if (value !== '') {
                    fz.add($(el).text());
                    districtLicenses[$(el).text()] = value;
                }
            });

        const spreadsheetLicenses = {};
        $('#bulk-uploads-licenses .spreadsheet_license').each((index, el) => {
            const result = fz.get($(el).text());
            if (
                typeof result !== 'undefined'
                && result != null
                && result.length > 0
                && result[0][0] > 0.5
                && typeof districtLicenses[result[0][1]] !== 'undefined'
            ) {
                spreadsheetLicenses[$(el).text()] = districtLicenses[result[0][1]];
            }
        });

        $('#bulk-uploads-licenses .bulk-upload-license-row').each((index, el) => {
            const spreadsheetLicense = $(el).find('.spreadsheet_license').text();
            const selectedValue = $(el).find('.license-id-selection').val();
            if (selectedValue === '' && typeof spreadsheetLicenses[spreadsheetLicense] !== 'undefined') {
                $(el).find('.license-id-selection').val(spreadsheetLicenses[spreadsheetLicense]);
            }
        });

        $('#bulk-uploads-licenses .license-id-selection').each((index, el) => {
            const value = $(el).val();
            if (value === '') {
                $('#queue-button').prop('disabled', true);
            }
        });

        $('#bulk-uploads-licenses').on('change', '.license-id-selection', () => {
            let allSelected = true;
            $('#bulk-uploads-licenses .license-id-selection').each((index, el) => {
                const value = $(el).val();
                if (value === '') {
                    allSelected = false;
                }
            });

            $('#queue-button').prop('disabled', !allSelected);
        });
    };

    return {
        init,
    };
}());
